import api from './axios';

export const notificationsAPI = {
  /**
   * GET /api/notifications?page=1&per_page=10
   */
  getList: (page = 1, perPage = 10) =>
    api.get('/notifications', { params: { page, per_page: perPage } }),
};
